import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle.js";
import { type_constant } from "../utils/asyncStatus.js";

export const getReports = createAsyncThunk(
  'reports/fetchReports',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiHandle.post('/admin/generate-report', { 
        filters: {
          startDate: params.startDate,
          endDate: params.endDate
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
)

